import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { IRadioBoxViewModelConstructorParameter } from "#/DefaultViewExtensionInterfaces";

export default class RadioBoxViewModel extends ControlViewModel {

    /**
     * Definiert den selektierten Wert
     */
    public checked: KnockoutObservable<string>;

    /**
     * Name der RadioBox
     */
    public name: string;

    /**
     * Wert der RadioBox
     */
    public value: any;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die RadioBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: IRadioBoxViewModelConstructorParameter) {
        super(params);

        this.checked = this.observableOrDefault(params.checked).extend({ notify: 'always' });
        this.name = this.paramOrDefault(params.name, null);
        this.value = this.paramOrDefault(params.value, null);
        this.label = this.paramOrDefault(params.label, null);
    }
}

ComponentManager.setViewModel('RadioBoxViewModel', RadioBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');